import styled from 'styled-components';

import { ReactComponent as ArrowDownIcon } from '../../../../assets/images/blueTheme/arrow.svg';
import { ReactComponent as ArrowUpIcon } from '../../../../assets/images/blueTheme/arrow.svg';
import { ReactComponent as SortIcon } from '../../../../assets/images/blueTheme/sort.svg';
import { HeaderIconBasedStyles } from '../styled';

export const StyledSortArrow = styled(SortIcon)`
  ${HeaderIconBasedStyles}
`;

export const StyledSortArrowUp = styled(ArrowDownIcon)`
  ${HeaderIconBasedStyles}
`;

export const StyledSortArrowDown = styled(ArrowUpIcon)`
  ${HeaderIconBasedStyles};

  transform: rotate(180deg);
`;
